import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import managementReducer from "./slices/managementSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    management: managementReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
